import { useEffect } from 'react'

import Box from '@totallymoney/ui/components/Box'
import Grid from '@totallymoney/ui/components/Grid'
import Icon from '@totallymoney/ui/icons/Icon'

import { KbaScenario } from '@config/kbaScenarioKeys'

import useLogEvents from '@hooks/useLogEvents'

import { Wrapper } from './KbaStatusBanner.styled'
import { KbaStatusMessage } from './components/KbaStatusMessage'

const KbaStatusBanner = ({ kbaScenario }: { kbaScenario: KbaScenario }) => {
    const logEvents = useLogEvents()

    useEffect(() => {
        logEvents.logBannerKbaDisplayEvent({ scenario: kbaScenario })
    }, [])

    const onKbaScenarioPress = (kbaScenario: KbaScenario) => {
        logEvents.logBannerKbaClickEvent({ scenario: kbaScenario })
    }

    return (
        <Grid>
            <Wrapper>
                <Box
                    display="flex"
                    backgroundColor="alertInfo100"
                    size="40px"
                    borderRadius="borderRadius10"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Icon icon="info" size={18} title="Information" />
                </Box>

                <Box display="flex" alignItems="center">
                    <KbaStatusMessage
                        kbaScenario={kbaScenario}
                        onKbaScenarioPress={onKbaScenarioPress}
                    />
                </Box>
            </Wrapper>
        </Grid>
    )
}

export default KbaStatusBanner
